import axios, { AxiosResponse } from 'axios'
import { ArquivoDto } from '../../../atendimento/core/_models'

const API_URL = process.env.REACT_APP_API_URL

/**
 * Exporta a trilha de auditoria em formato CSV para o período especificado.
 * @param dataInicio - Data Inicio
 * @param dataFim - Data Fim
 * @returns ArquivoDto
 */
export const exportarAuditoriaCsv = (dataInicio: string, dataFim: string): Promise<ArquivoDto> => {
  return axios
    .get(`${API_URL}/auditoria/exportar`, {
      params: { dataInicio, dataFim },
    })
    .then((resp: AxiosResponse<ArquivoDto>) => resp.data)
}
